export class ProtocolGuards {
    static bulk(value) {
        if (!this.record(value) ||
            (value.status !== undefined &&
                (typeof value.status !== "number" || Number.isNaN(value.status))) ||
            (value.message !== undefined && typeof value.message !== "string"))
            return false;
        if (value.results === undefined)
            return true;
        if (!Array.isArray(value.results))
            return false;
        return value.results.every((result) => this.record(result) &&
            (result.reqId === undefined || typeof result.reqId === "string") &&
            (result.response === undefined ||
                typeof result.response === "string" ||
                this.bulkChild(result.response) !== undefined) &&
            (result.message === undefined || typeof result.message === "string") &&
            (result.status === undefined ||
                (typeof result.status === "number" && !Number.isNaN(result.status))));
    }
    static bulkChild(value) {
        let decoded = value;
        if (typeof value === "string") {
            try {
                decoded = JSON.parse(value);
            }
            catch {
                return undefined;
            }
        }
        if (!this.record(decoded))
            return undefined;
        const envelope = this.entityQuery(decoded);
        if (!envelope.success)
            return undefined;
        if (decoded.message != null && typeof decoded.message !== "string")
            return undefined;
        return envelope.data;
    }
    static entityQuery(value) {
        if (!this.record(value) ||
            (value.status !== undefined &&
                (typeof value.status !== "number" || Number.isNaN(value.status))) ||
            (value.totalCount !== undefined &&
                (typeof value.totalCount !== "number" ||
                    Number.isNaN(value.totalCount))) ||
            (value.success !== undefined && typeof value.success !== "boolean"))
            return { success: false };
        const entities = [];
        if (value.entities !== undefined) {
            if (!Array.isArray(value.entities))
                return { success: false };
            for (const entity of value.entities) {
                if (!this.record(entity))
                    return { success: false };
                entities.push(entity);
            }
        }
        return {
            success: true,
            data: {
                ...value,
                ...(typeof value.status === "number" ? { status: value.status } : {}),
                ...(typeof value.totalCount === "number"
                    ? { totalCount: value.totalCount }
                    : {}),
                ...(typeof value.success === "boolean"
                    ? { success: value.success }
                    : {}),
                ...(value.entities === undefined ? {} : { entities }),
            },
        };
    }
    static record(value) {
        return typeof value === "object" && value !== null && !Array.isArray(value);
    }
    static httpPayload(value) {
        if (!this.record(value) || !this.record(value.error))
            return undefined;
        const error = value.error;
        if (typeof error.code !== "string" || typeof error.message !== "string")
            return undefined;
        if (error.details !== undefined && !this.record(error.details))
            return undefined;
        const issues = [];
        if (error.issues !== undefined) {
            if (!Array.isArray(error.issues))
                return undefined;
            for (const issue of error.issues) {
                if (!this.record(issue) ||
                    typeof issue.code !== "string" ||
                    typeof issue.field !== "string" ||
                    typeof issue.message !== "string")
                    return undefined;
                issues.push({
                    ...issue,
                    code: issue.code,
                    field: issue.field,
                    message: issue.message,
                });
            }
        }
        return {
            ...error,
            code: error.code,
            message: error.message,
            issues,
            ...(error.details === undefined ? {} : { details: error.details }),
        };
    }
    static httpFallback(value) {
        if (!this.record(value) ||
            typeof value.message !== "string" ||
            value.message.length === 0 ||
            (value.logId !== undefined && typeof value.logId !== "string") ||
            (value.systemLogId !== undefined && typeof value.systemLogId !== "string"))
            return undefined;
        return {
            ...value,
            message: value.message,
            ...(typeof value.logId === "string" ? { logId: value.logId } : {}),
            ...(typeof value.systemLogId === "string"
                ? { systemLogId: value.systemLogId }
                : {}),
        };
    }
}
//# sourceMappingURL=protocol.js.map